module.exports = __webpack_public_path__ + "static/img/CgoRDGORj0OAM43KAAEQIjlckck895.092380f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CgoRDGORj0OAM43KAAEQIjlckck895.png
// module id = LN3n
// module chunks = 73